export default "__VITE_ASSET__BjmfCO9n__"